// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmAction-module__confirmActionContainer {
  display: flex;
  width: 400px;
  padding: 22px 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.ConfirmAction-module__closeHeader {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.ConfirmAction-module__closeBtn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.ConfirmAction-module__confirmActionContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
}

.ConfirmAction-module__confirmActionTitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

.ConfirmAction-module__confirmActionTitle h2 {
  color: #1e2a36;
  font-family: Montserrat;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 167%;
  margin: 0;
}
.ConfirmAction-module__confirmActionDescription{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
}
.ConfirmAction-module__confirmActionDescription p {
    color: #324452;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}
.ConfirmAction-module__dontShowAgainSection {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  align-self: stretch;
}

.ConfirmAction-module__dontShowAgainSection input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #263643;
}

.ConfirmAction-module__dontShowAgainSection label {
  color: #324452;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
}

.ConfirmAction-module__submitButtonSection {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ConfirmAction-module__cancelButton {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1;
  border-radius: 70px;
  border: 1px solid #263643;
  background-color: #fff;
  color: #263643;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  cursor: pointer;
}

.ConfirmAction-module__proceedButton {
  display: flex;
  height: 50px;
  padding: 0px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1;
  border: none;
  border-radius: 56px;
  background: #263643;
  color: #fff;
  text-align: center;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.56px;
  text-transform: uppercase;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/modals/confirmaction/ConfirmAction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mDAAmD;EACnD,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".confirmActionContainer {\n  display: flex;\n  width: 400px;\n  padding: 22px 24px;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n}\n\n.closeHeader {\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.closeBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.confirmActionContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  width: 100%;\n}\n\n.confirmActionTitle {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n}\n\n.confirmActionTitle h2 {\n  color: #1e2a36;\n  font-family: Montserrat;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 167%;\n  margin: 0;\n}\n.confirmActionDescription{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    align-self: stretch;\n}\n.confirmActionDescription p {\n    color: #324452;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n}\n.dontShowAgainSection {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 14px;\n  align-self: stretch;\n}\n\n.dontShowAgainSection input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #263643;\n}\n\n.dontShowAgainSection label {\n  color: #324452;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n  cursor: pointer;\n}\n\n.submitButtonSection {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.cancelButton {\n  display: flex;\n  height: 50px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  border-radius: 70px;\n  border: 1px solid #263643;\n  background-color: #fff;\n  color: #263643;\n  text-align: center;\n  font-variant-numeric: lining-nums proportional-nums;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.56px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.proceedButton {\n  display: flex;\n  height: 50px;\n  padding: 0px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  border: none;\n  border-radius: 56px;\n  background: #263643;\n  color: #fff;\n  text-align: center;\n  font-family: Montserrat;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.56px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmActionContainer": `ConfirmAction-module__confirmActionContainer`,
	"closeHeader": `ConfirmAction-module__closeHeader`,
	"closeBtn": `ConfirmAction-module__closeBtn`,
	"confirmActionContent": `ConfirmAction-module__confirmActionContent`,
	"confirmActionTitle": `ConfirmAction-module__confirmActionTitle`,
	"confirmActionDescription": `ConfirmAction-module__confirmActionDescription`,
	"dontShowAgainSection": `ConfirmAction-module__dontShowAgainSection`,
	"submitButtonSection": `ConfirmAction-module__submitButtonSection`,
	"cancelButton": `ConfirmAction-module__cancelButton`,
	"proceedButton": `ConfirmAction-module__proceedButton`
};
export default ___CSS_LOADER_EXPORT___;
